export const getUserWinningItems = (state, gameTypeId) => {
  return state.prize.trades[gameTypeId];
};

export const getWinningModalVisibleStatus = ({ prize }) => prize.isVisible;

export const getGameTypeIdTrade = ({ prize }) => prize.trades.gameTypeId;
